import SEOHead from "@/components/SEOHead";
import { Award, ShieldCheck, Sparkles, Users } from "lucide-react";

const VALUES = [
  { icon: Award, title: "Tournament Grade", desc: "Pro turf, league lighting and electronic scoring. Built to host real cricket, not casual hits." },
  { icon: ShieldCheck, title: "Safety First", desc: "Padded boundaries, certified equipment and full-time staff on every session." },
  { icon: Users, title: "League Community", desc: "Weekly leagues, corporate tournaments and a fan base that fills the stands every floodlit night." },
  { icon: Sparkles, title: "Always Something On", desc: "Open from morning to midnight. Private bookings, leagues and watch-parties on every match weekend." },
];

export default function About() {
  return (
    <div data-testid="about-page" className="bg-[var(--pz-ink)] text-white">
      <SEOHead title="About — The Arena" description="The story behind The Arena — Sri Lanka's premier indoor cricket club for adults and teens." />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            <div className="text-xs uppercase tracking-[0.35em] text-[var(--pz-red)] font-bold mb-4">Our Story</div>
            <h1 className="font-display text-5xl md:text-7xl font-bold uppercase leading-none">Built for the love of the game.</h1>
            <p className="mt-7 text-zinc-400 text-lg max-w-xl">The Arena started with one obsession — making indoor cricket feel as serious as the outdoor format. Pro turf, electronic scoring, real referees and a fan culture that turns Saturday nights into proper sporting events.</p>
            <p className="mt-4 text-zinc-400 max-w-xl">Today we run a 24-team Premier League, host corporate sixes for every major office in the city, and turn the lights on for private bookings until midnight.</p>
          </div>
          <div className="relative">
            <img src="https://images.unsplash.com/photo-1531415074968-036ba1b575da?auto=format&fit=crop&w=1200&q=80" alt="The Arena" className="rounded-md w-full aspect-[4/3] object-cover" />
            <div className="absolute -bottom-4 -right-4 bg-[var(--pz-red)] text-white px-6 py-4 font-display uppercase tracking-wide font-bold text-sm hidden sm:block">25+ Years Strong</div>
          </div>
        </div>

        <div className="mt-24 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {VALUES.map((v, i) => {
            const I = v.icon;
            return (
              <div key={i} className="bg-[var(--pz-ink-2)] border border-[var(--pz-line)] rounded-md p-6 pz-fade-up" style={{ animationDelay: `${i * 80}ms` }}>
                <div className="h-12 w-12 rounded-md bg-[var(--pz-red)] text-white grid place-items-center mb-4"><I className="h-5 w-5" /></div>
                <h3 className="font-display text-xl font-bold uppercase">{v.title}</h3>
                <p className="text-zinc-400 text-sm mt-2">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
